import { Controller } from "@hotwired/stimulus"

// Abhängige Auswahl: Wechselt der Wert des Ziels parent (z. B. Projekt),
// bekommt das Ziel child (z. B. Kostenträger) die Optionen aus
// data-dependent-select-options-value, also { parentWert: [{ value, text, group }] }.
// Optionen mit group landen in einer <optgroup>. Hängt an child ein Tom Select,
// wird es neu synchronisiert. Ersetzt den Projekt-Handler aus admin/tasks.js.erb.
export default class extends Controller {
  static targets = ["parent", "child"]
  static values = { options: Object }

  connect() {
    this.lastParentValue = this.parentTarget.value
  }

  update() {
    const value = this.parentTarget.value
    if (value === this.lastParentValue) return

    this.lastParentValue = value
    const tomSelect = this.childTarget.tomselect
    tomSelect?.clear(true)
    tomSelect?.clearOptions()
    tomSelect?.clearOptionGroups()

    this.childTarget.replaceChildren(...this.buildOptions(this.optionsValue[value] || []))

    tomSelect?.sync()
  }

  buildOptions(entries) {
    const nodes = []
    const groups = new Map()

    for (const { value, text, group } of entries) {
      const option = document.createElement("option")
      option.value = value
      option.textContent = text
      if (!group) {
        nodes.push(option)
        continue
      }
      if (!groups.has(group)) {
        const optgroup = document.createElement("optgroup")
        optgroup.label = group
        groups.set(group, optgroup)
        nodes.push(optgroup)
      }
      groups.get(group).append(option)
    }
    return nodes
  }
}
